import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationProblemType as SchemaIntegrationProblemType } from '../schemas/IntegrationProblemType';
import { type IntegrationSyncType as SchemaIntegrationSyncType } from '../schemas/IntegrationSyncType';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const IntegrationsStartTypeContentType = '' as const;
export type IntegrationsStartTypeRequest = void;
export type IntegrationsStartTypeResponses = LinkCommonErrorResponses & {
    /**
     * @description Integration sync started successfully
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaIntegrationProblemType;
        };
    };
};
export type IntegrationsStartTypeResponseSuccess = undefined;
export type IntegrationsStartTypeSearchParams = undefined;
export type IntegrationsStartTypePathParameters = {
    type: SchemaIntegrationSyncType;
};
export const IntegrationsStartTypeUrl = '/integrations/type/{type}/start' as const;
export const IntegrationsStartTypeMethod = 'POST' as const;
export const getIntegrationsStartTypeUrl = (params: IntegrationsStartTypePathParameters) =>
    IntegrationsStartTypeUrl.replace(/\{(\w+)\}/g, (_match, param: keyof IntegrationsStartTypePathParameters) =>
        String(params[param])
    );
